/** 十进制序号不经Number转换，避免大于2^53后错序。 */
export function compareSequence(a, b) {
  a = String(a); b = String(b);
  if (![a, b].every(s => /^(0|[1-9][0-9]{0,18})$/.test(s) && (s.length < 19 || s <= "9223372036854775807"))) throw new Error("Invalid sync sequence");
  return a.length === b.length ? a === b ? 0 : a < b ? -1 : 1 : a.length < b.length ? -1 : 1;
}
const body = response => {
  if (Number(response?.code) !== 200) throw Object.assign(new Error("实时事件恢复失败"), { code: response?.errorCode || response?.code });
  return response.data;
};
/** 逐资源游标向量：每轮最多8个请求；续读保留分页位置，不使用全局自增ID跳过未提交事件。 */
export class RealtimeRecovery {
  constructor(options) { this.options = options; this.positions = new Map(); this.queue = []; this.scan = { channel: "", resource: "" }; this.scanDone = false; this.closed = false; }
  async recover() {
    if (this.closed) return;
    for (let budget = 0; budget < 8 && !this.closed; budget++) {
      if (!this.queue.length) {
        if (this.scanDone) { this.scan = { channel: "", resource: "" }; this.scanDone = false; return; }
        let response;
        try { response = await this.options.getResources(this.scan); }
        catch (error) { if (error.response?.status === 404) return; throw error; }
        if (this.closed) return;
        if (Number(response?.code) === 404) return; // 旧MTS兼容入口；保留既有恢复机制。
        const page = body(response);
        if (!page.enabled) return;
        this.queue.push(...page.items); this.scanDone = !page.hasMore;
        if (page.hasMore) {
          if (!page.nextChannel || !page.nextResource || page.nextChannel === this.scan.channel && page.nextResource === this.scan.resource) throw new Error("实时资源分页未推进");
          this.scan = { channel: page.nextChannel, resource: page.nextResource };
        }
        continue;
      }
      const resource = this.queue[0], key = `${resource.channel}:${resource.resourceId}`;
      const after = this.positions.get(key) || "0";
      if (compareSequence(after, resource.eventSequence) === 0) { this.queue.shift(); budget--; continue; }
      let response;
      try { response = await this.options.getEvents({ channel: resource.channel, resource: resource.resourceId, afterEventSequence: after }); }
      catch (error) { if ([403, 404].includes(error.response?.status)) response = { code: error.response.status }; else throw error; }
      if (this.closed) return;
      if ([403, 404].includes(Number(response?.code))) {
        await this.options.onEvent({ schemaVersion: 1, contractVersion: "xsou.realtime.v1", type: "EVENT", eventId: `revoked:${key}`, eventType: "resource.revoked", channel: resource.channel, resourceId: resource.resourceId, payload: { type: "RESOURCE_REVOKED" } });
        this.positions.delete(key); this.queue.shift(); continue;
      }
      if (response?.errorCode === "EVENT_CURSOR_RESET_REQUIRED") {
        // 服务端保留边界变化时通知业务重建权威快照，再从边界恢复事件。
        await this.options.onEvent({ schemaVersion: 1, contractVersion: "xsou.realtime.v1", type: "EVENT", eventId: `reset:${key}:${resource.eventSequence}`, eventType: "resource.changed", channel: resource.channel, resourceId: resource.resourceId, payload: { type: "SYNC_RESET" } });
        this.positions.set(key, resource.retainedFromSequence); continue;
      }
      const page = body(response);
      if (compareSequence(page.throughEventSequence, after) < 0 || page.hasMore && compareSequence(page.throughEventSequence, after) === 0) throw new Error("实时事件分页未推进");
      for (const event of page.items) { if (this.closed) return; await this.options.onEvent(event); }
      if (this.closed) return;
      this.positions.set(key, page.throughEventSequence);
      if (!page.hasMore) this.queue.shift();
    }
    if (!this.closed && (this.queue.length || !this.scanDone)) this.options.onMore?.();
    else { this.scan = { channel: "", resource: "" }; this.scanDone = false; }
  }
  close() { this.closed = true; this.positions.clear(); this.queue = []; }
}
